import { Grid } from "@mui/material";
import { useState } from "react";
import CustomButton from "../../../../components/CustomButton";
import Hospitalization from "./Hospitalization";
import Surgery from "./Surgery";

const InpatientNew = ({ setSelectedTab, selectedVet }) => {
  const [activeTab, setActiveTab] = useState("Surgery");

  const handleChangeTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="back-white pv10 ph15 br5">
            <div className="flex-row">
              <div className="w10Per">
                <CustomButton
                  text="Surgery"
                  onClick={() => handleChangeTab("Surgery")}
                  tabOutlined
                  yellowBtn={activeTab === "Surgery"}
                />
              </div>
              <div className="w5Per">
                <div className="flex-center">
                  <div className="ver-bar-h30" />
                </div>
              </div>
              <div className="w10Per">
                <CustomButton
                  text="Hospitalization"
                  onClick={() => handleChangeTab("Hospitalization")}
                  tabOutlined
                  yellowBtn={activeTab === "Hospitalization"}
                />
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
      {activeTab === "Surgery" && <Surgery selectedVet={selectedVet} />}
      {activeTab === "Hospitalization" && (
        <Hospitalization selectedVet={selectedVet} />
      )}
    </>
  );
};

export default InpatientNew;
